import { render, staticRenderFns } from "./RuleManagerDmMatchAndAssignRules.vue?vue&type=template&id=3cc8766f&scoped=true&"
import script from "./RuleManagerDmMatchAndAssignRules.vue?vue&type=script&lang=js&"
export * from "./RuleManagerDmMatchAndAssignRules.vue?vue&type=script&lang=js&"
import style0 from "./RuleManagerDmMatchAndAssignRules.vue?vue&type=style&index=0&id=3cc8766f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8766f",
  null
  
)

export default component.exports